
import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

// Custom components
import CircularProgress from '@material-ui/core/CircularProgress';

// Material components
import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';

//Service
import {getEvents} from '../../../../../../services/getEvents';
import codes_ok from '../../../../../../data/codes_ok'
import codes from '../../../../../../data/at_error_codes'

// Component styles
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')


class DistributionAvailability extends Component {
    constructor(props) {
        super(props);
        // console.log('dc', props.data.step)
        this.state = {
            node:this.props.data.node,
            objective:this.props.match.params,
            step:this.props.data.step,
            dateBegin:this.props.data.range.startDate,
            finalDate:this.props.data.range.endDate,
            isLoad:true,
            error:false,
        };
    }
    componentDidMount() {
        //console.log('inicio')
        this.getData()
    }

    static getDerivedStateFromProps(props, state) {
        //console.log('derived', moment(props.data.range.startDate).format("Y-MM-DD"), moment(state.dateBegin).format("Y-MM-DD"))
        //console.log(props.data.range.endDate,state.finalDate)
        if(props.data.step.id_paso!==state.step.id_paso){
            return{
                step:props.data.step,
                isLoad:true,
            }
        }
        if( moment(props.data.range.startDate).format("Y-MM-DD")!==moment(state.dateBegin).format("Y-MM-DD")){
            return{
                dateBegin:props.data.range.startDate,
                finalDate:props.data.range.endDate,
                isLoad:true,
            }    
        }
        return null
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log(moment(prevProps.data.range.startDate).format("Y-MM-DD"),moment(this.state.dateBegin).format("Y-MM-DD"))
        if(prevProps.data.step.id_paso!== this.state.step.id_paso
            ||moment(prevProps.data.range.startDate).format("Y-MM-DD")!==moment(this.state.dateBegin).format("Y-MM-DD")
            ){
                //console.log('up')
            this.getData()
        }
    }

    getData=()=>{
        //console.log('data')
        //console.log('get',this.state)
        const {dateBegin, finalDate,objective,node}=this.state
        //console.log(dateBegin, finalDate, objective, node)
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        //console.log(objective)
        //console.log(dateBegin)
        var fecha_inicio=moment(dateBegin).format("Y-MM-DD HH:mm")
        var fecha_termino=moment(finalDate).format("Y-MM-DD HH:mm")
        //console.log(fecha_inicio, fecha_termino)
        getEvents(user, objective.objetivo_id, fecha_inicio, fecha_termino, token).then(Events=>{
            if (Events.status == 1 || Events.status == 5) {
                localStorage.setItem('isAuthenticated', false);
            } else {
                //Procesa la Data Recibida
                try {
                    this.processData(Events)
                } catch (error) {  
                    // console.log(error)                   
                    this.setState({
                        error: true,
                        isLoad: false
                    });
                }
            }
        })
        
    }

    processData=(data)=>{
        // console.log('process', data)
        const {step}=this.state
        // console.log('step', step)
        //console.log(data)
        var listIsps=[]
        var listError=[]
        data.map(isp=>{
            //console.log(isp.nombre_nodo)
            var listEvents=[]
            var totalResult=0
            isp.data_nodo.map(eventos=>{
                eventos.map(evento=>{
                    let dateHasta = (new Date(evento.hasta))
                    let dateDesde = (new Date(evento.desde))
                    let result = dateHasta - dateDesde
                    //console.log(result)
                    var status =0
                    if(typeof((evento.pasos.filter(paso=>paso.id===step.id_paso))[0].patrones)==='undefined'){
                        var statusStep = ((evento.pasos.filter(paso=>paso.id===step.id_paso))[0].estado)
                        if (statusStep !== '') {
                            status=((evento.pasos.filter(paso=>paso.id===step.id_paso))[0].estado)    
                        } 
                        
                    }else{
                        (evento.pasos.filter(paso=>paso.id===step.id_paso)[0].patrones).map(ele=>{
                            if((codes_ok.map(i=>i.id)).includes(parseInt(ele.estado))===false){
                                status=ele.estado
                            }
                        })
                    }
                    // console.log(status)
                    if(status!=='sin monitoreo'){
                        if((codes_ok.map(i=>i.id)).includes(parseInt(status))===false){
                            //console.log(status)
                            listEvents[parseInt(status)]=listEvents[parseInt(status)] ? (listEvents[parseInt(status)] + 1) : 1
                            listEvents[parseInt(status)]+=result
                            totalResult+=result
                            if(listError.includes(parseInt(status))===false){
                                listError.push(status)
                            }
                        }
                    }
                })
                
            })
            if(totalResult!==0){
                var factor=100/(totalResult)
                //console.log(Object.keys(listEvents.filter(i=>i)))
                listIsps[isp.nombre_nodo]=[]
                Object.keys(listEvents).map(element=>{
                    var dictError={"id_error":element,'porcentaje_error': parseFloat((listEvents[element]*factor).toFixed(2))}
                    listIsps[isp.nombre_nodo].push(dictError)
                })
            }
            
        })
        
        listError=(Array.from(new Set(listError)))
        // console.log('listips',listIsps, (listError))
        //AGREGA DATOS A ERRORES QUE NO EXISTEN EN OTRO NODO
        var newListNodes=[]
        Object.keys(listIsps).map(isp=>{
            //console.log(isp, listIsps[isp])
            if(listError.length!==listIsps[isp].length){
                
                listError.map(error=>{
                    var dictError={}
                    //console.log((listIsps[isp].map(i=>i.id_error)), error)
                    if((listIsps[isp].map(i=>i.id_error)).includes(String(error))===false){
                        //console.log('se incluye error', error)
                        dictError["id_error"]=String(error)
                        dictError['porcentaje_error']= 0
                        listIsps[isp].push(dictError)
                    }
                })
            }
            //console.log(listIsps[isp])
            newListNodes.push({'name':isp,'data':listIsps[isp]})
        })
        // console.log(listError, newListNodes)
        //CREA DATA PARA HIGHCHART
        var listData=[]

       
        
        listError.map(error=>{
            var code = codes.filter(i=>i.id===parseInt(error))
            
            if(code.length > 0){
                var errorData=(codes.filter(i=>i.id===parseInt(error))[0])
                var listValues=[]
                newListNodes.map(ele=>{
                    (ele.data).map(codes=>{
                        //console.log(codes.id_error, error)
                        if(parseInt(codes.id_error)===parseInt(error)){
                            listValues.push(codes.porcentaje_error)
                        }
                    })
                })
                listData.push({'name':errorData.nombre, 'data':listValues})
            }
                        
        })
        if (listData.length === 0) {
            listData.push({'name':'Sin Errores'})
        }
        // console.log("listData",listData)

        this.setState({
            chartOptions: {
                colors: ['#DF7401', '#FFFF00', '#00FF80', '#0000FF', '#64E572', '#FF9655', '#FFF263','#6AF9C4'],
                chart: {
                    type: 'column'
                },
                title: {
                    text: 'Disponibilidad',
                    style: {
                        color: '',
                        fontWeight: '',
                        fontSize: '' 
                    },
                    margin: 25,
                },

                subtitle: {
                    text: '',
                    style: {
                        color: '',
                        fontWeight: '',
                        fontSize: '',
                    }
                },
                xAxis: {
                    //categories:['a,b']
                    categories:newListNodes.map(ele=>ele.name)
                },
                yAxis: {
                    max:100,
                    title: {
                        text: 'Errores (%)'
                    },
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                //series:[{'name':15, 'data':[1,2]},{'name':3, 'data':[1,2]}],
                series:listData,
                credits: {
                    enabled: false
                },
            },

            isLoad: false,
            error:false
        });
    }

    render() {
        const {isLoad, error,chartOptions,step}=this.state
        
        // console.log('render', step, "   ", error)
        if(error!==true){
            if (isLoad===true) {
                //console.log('vista rapida render carga', this.state)
                return(
                    <Grid
                        container
                        spacing={1}
                    >
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            xl={6}
                            style={{textAlign:"right"}}    
                        >
                            <CircularProgress variant="indeterminate" size={24} thickness={4} />
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            xl={6}
                        >
                            <Typography variant="h5" color="primary" style={{color:"#525252"}}> Cargando Información...</Typography>
                        </Grid>
                    </Grid>
                )
            }else{
                //console.log('vista rapida render carga', this.state)
                sessionStorage.setItem("chartDistributionAvailability"+String(step.id_paso),JSON.stringify(chartOptions))
                return(<PerfectScrollbar>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            xl={12}
                            style={{paddingLeft:"200px"}}
                        >
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={this.state.chartOptions}
                            />
                        </Grid>
                    </PerfectScrollbar>)
            }   
        }else{
            return(<div>error</div>)
        }
    }
}

export default
    compose(withRouter, withStyles(styles))(DistributionAvailability);